( function ( $ ) {
  "use strict";

  var navbar = $('.navbar');
  navbar.addClass('js-initialized');
  var desktopLayoutMQ = window.matchMedia('(min-width: 1200px)');

  $('#menu-main > li > .sub-menu').each(function () {
    var $subMenu = $(this);

    $subMenu.toggleClass('has-nav-collapsible', 0 < $subMenu.find('.nav-collapsible').length)
  });

  //
  // Nav Collapsible
  //
  $('.nav-toggle-open').on('click', function() {
    var button = $(this);

    var open = button.hasClass('open');

    var collapsible = button.siblings().filter('.collapse-wrapper');

    if (open) {
      // close
      button.removeClass('open');
    } else {
      button.addClass('open');
    }
    updateCollapsible(collapsible, !open);
  });

  function updateCollapsible(collapsible, open) {
    if (open) {
      collapsible.css('max-height', collapsible.children().eq(0).height() + 'px');
    } else {
      collapsible.css('max-height', '');
    }
  }

  function updateCollapsibles() {
    $('.nav-toggle-open').each(function(idx, el) {
      var button = $(this);

      var open = button.hasClass('open');
      var collapsible = button.siblings().filter('.collapse-wrapper');
      updateCollapsible(collapsible, open);
    });
  }
  $(window).on('resize', updateCollapsibles);

  var wasDesktop = desktopLayoutMQ.matches;
  var onResize = function() {
    if (!wasDesktop && desktopLayoutMQ.matches) {
      $('body').removeClass('overflow-hidden position-fixed');
    }
    if (wasDesktop && !desktopLayoutMQ.matches && $('#navbarNavMobile').hasClass('show')) {
      $('body').addClass('overflow-hidden position-fixed');
    }
    wasDesktop = desktopLayoutMQ.matches;
  }
  $(window).on('resize', onResize.bind(this));


  // Touch on Desktop Fallback
  $('.navbar-nav > li > a').on('touchstart', function(evt) {
    if (!window.matchMedia('(min-width: 1200px)').matches) return;
    var scope = this;
    scope.hasBeenTouchedRecently = true;
    setTimeout(function() { scope.hasBeenTouchedRecently = false; }, 500);
  });

  $('.navbar-nav > li > a').on('click', function(evt) {
    if (!window.matchMedia('(min-width: 1200px)').matches) return;
    if (!this.hasBeenTouchedRecently) return;
    var panel = $(evt.currentTarget).closest('li')
    var panelOpen = panel.hasClass('js-hovering');

    if (!panelOpen) {
      evt.preventDefault();
      $('.navbar .js-hovering').removeClass('js-hovering');
      panel.addClass('js-hovering');
      return false;
    }
  });
  $(window).on('touchstart', function(evt) {
    if (!window.matchMedia('(min-width: 1200px)').matches) return;
    var partOfNavbar = $(evt.target).closest('.navbar-nav').length > 0;

    if (!partOfNavbar) {
      // clicked outside -> remove all
      $('.navbar .js-hovering').removeClass('js-hovering');
    }
  });

  // Positioning
  var subNavsLvl2 = navbar.find('.navbar-nav > li > ul');
  function positionSubNavs() {
    if (!desktopLayoutMQ.matches) return;
    var navbarWidth = navbar.width();
    var navbarOffset = navbar.offset();
    subNavsLvl2.each(function(idx, el) {
      var subNav = $(el);
      var parent = subNav.parent();
      var widthSubNav = subNav.width();
      var widthParent = parent.width();
      var offsetParent = parent.offset();
      var centerParent = offsetParent.left - navbarOffset.left + widthParent / 2;

      // center
      var offsetRight = navbarWidth - centerParent - widthSubNav / 2;
      if (offsetRight < 0 || widthSubNav > navbarWidth) {
        offsetRight = 0;
      } else if (centerParent - widthSubNav / 2 < 0) {
        offsetRight = navbarWidth - widthSubNav;
      }

      subNav.data('offsetRight', offsetRight);
    });
    subNavsLvl2.each(function(idx, el) {
      var subNav = $(el);
      subNav.css('right', subNav.data('offsetRight') + 'px');
    });
  }
  positionSubNavs();
  window.addEventListener('resize', positionSubNavs.bind(this));

} )( jQuery );
